import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import RoundedButton from "components/Buttons/RoundedButton";
import ImgSuccess from "../../../../assets/images/afinandinho-cadastro-sucesso.svg";
import { R_DASHBOARD } from "../../../../constants/routes";
import SystemContext from "../../../../context/SystemContext";
import { useSelector } from "react-redux";

const RegisterSuccessScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { session } = useSelector((state) => state.session);
  const [sendEventState, setSendEventState] = useState(0);
  const { updateTagUser, tagMapToSend } = useContext(SystemContext);

  useEffect(() => {
    if (session && sendEventState == 0) {
      updateTagUser(tagMapToSend["thanks_page"]);
      setSendEventState(1);
    }
  }, [session, sendEventState]);

  return (
    // Container principal que centraliza o conteúdo na tela
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Fundo roxo com cantos curvos (simulando o layout da imagem) */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: "-1%", md: "-10%" },
          left: "50%",
          width: { xs: "100%", md: "120%" },
          height: { xs: "95%", sm: "110%", md: "120%" },
          backgroundColor: "#6a1b9a",
          borderBottomLeftRadius: "500px",
          borderTopLeftRadius: "500px",
          zIndex: 0,
          transform: "rotate(0deg)",
        }}
      />

      {/* Cartão branco com o conteúdo do sucesso do cadastro */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: { xs: "center", md: "space-evenly" },
          minWidth: "360px",
          border: "4px solid #f6a940",
          borderRadius: 2,
          backgroundColor: "#fff",
          mt: { xs: "100px", md: "80px" },
          mb: 3,
          padding: { xs: "24px", sm: "32px", md: "40px" },
          width: { xs: "90%", sm: "80%", md: "80%", lg: "90vw", xl: "80vw" },
          height: { xs: "80%", sm: "80%", md: "80%", lg: "75vh", xl: "75vh" },
          zIndex: 1,
        }}
      >
        {/* Título de sucesso */}
        <Typography
          variant="h4"
          // mb={2}
          sx={{
            align: "center",
            textAlign: "center",
            fontWeight: "bold",
            color: "#6a1b9a",
            fontSize: { xs: "1.13rem", sm: " 1.75rem" },
            marginBottom: { xs: "20px", sm: "40px", md: 0 },
          }}
        >
          {t("login_page.registration_completed_successfully")}
        </Typography>

        {/* Imagem de sucesso */}
        <Box
          component="img"
          src={ImgSuccess}
          alt="Cadastro com sucesso"
          sx={{
            width: {
              xs: "80%",
              sm: "320px",
            },
            maxWidth: "100%",
            display: "block",
            margin: "0 auto",
          }}
        />

        <Typography
          sx={{
            align: "center",
            textAlign: "center",
            fontWeight: "400",
            color: "#4d4d4d",
            fontSize: { xs: "1rem", sm: " 1.13rem" },
            marginTop: { xs: 0, md: "-50px" },
            marginBottom: { xs: "20px" },
          }}
        >
          {t("login_page.your_account_is_active")}
        </Typography>

        {/* Botão para acessar o perfil */}
        <Box
          sx={{
            display: "flex",
            maxWidth: "85vw",
            justifyContent: "space-around",
            marginTop: { xs: "20px", sm: "30px", md: 0 },
            fontSize: { xs: "1rem", sm: " 1.13rem" },
          }}
        >
          <RoundedButton
            text={t("login_page.access_my_profile")}
            onClick={() => {
              sessionStorage.removeItem("justRegistered");
              navigate(R_DASHBOARD);
            }}
            sx={{ width: "320px", height: "50px" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RegisterSuccessScreen;
